<script setup lang="ts">
import { HomeButton } from '@/components/home'
import { useSpecialCollectibleChallenge } from '@/composables/game/challenges'
import CollectibleChallengeIcon from '@/assets/images/challenges/collectible/collectible-challenge-main-nye.webp'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
	containerClass?: string
}>(), {
  containerClass: '',
})

const {
  countdown,
  isSpecialCollectibleChallengeLive,
  specialCollectibleChallengeName,
} = useSpecialCollectibleChallenge()
</script>

<template>
  <HomeButton
    v-if="isSpecialCollectibleChallengeLive"
    :label="specialCollectibleChallengeName"
    :countdown="{ value: countdown, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
    :button-class="twMerge('bg-[linear-gradient(180deg,#FCA904_0%,#BF4C00_55.77%,rgba(109,25,3,0)_100%)] p-1', containerClass)"
  >
    <img
      class="size-full object-cover z-[3]"
      :src="CollectibleChallengeIcon"
      alt="Collectible Hunt"
    >
  </HomeButton>
</template>
